export const GET_DEVICES_DATA = {
    INIT: "GET_DEVICES_DATA_INIT",
    SUCCESS: "GET_DEVICES_DATA_SUCCESS",
    ERROR: "GET_DEVICES_DATA_ERROR",
    CLEAR: "GET_DEVICES_DATA_CLEAR"
}

export const UPDATE_DEVICES_DATA = {
    INIT:    "UPDATE_DEVICES_DATA_INIT",
    SUCCESS: "UPDATE_DEVICES_DATA_SUCCESS",
    ERROR:   "UPDATE_DEVICES_DATA_ERROR",
    CLEAR:   "UPDATE_DEVICES_DATA_CLEAR"
}

export const DELETE_DEVICES_DATA = {
    INIT:    "DELETE_DEVICES_DATA_INIT",
    SUCCESS: "DELETE_DEVICES_DATA_SUCCESS",
    ERROR:   "DELETE_DEVICES_DATA_ERROR",
    CLEAR:   "DELETE_DEVICES_DATA_CLEAR"
}

export const GET_DEVICES_PING_STATUS = {
    INIT: "GET_DEVICES_PING_STATUS_INIT",
    SUCCESS: "GET_DEVICES_PING_STATUS_SUCCESS",
    ERROR: "GET_DEVICES_PING_STATUS_ERROR",
    CLEAR: "GET_DEVICES_PING_STATUS_CLEAR"
}

export const DEVICE_ONBOARDING = {
    INIT: "DEVICE_ONBOARDING_INIT",
    SUCCESS: "DEVICE_ONBOARDING_SUCCESS",
    ERROR: "DEVICE_ONBOARDING_ERROR",
    CLEAR: "DEVICE_ONBOARDING_CLEAR"
};

export const TOGGLE_DEVICES_MONITORING_STATUS = {
    INIT:    "TOGGLE_DEVICES_MONITORING_STATUS_INIT",
    SUCCESS: "TOGGLE_DEVICES_MONITORING_STATUS_SUCCESS",
    ERROR:   "TOGGLE_DEVICES_MONITORING_STATUS_ERROR",
    CLEAR:   "TOGGLE_DEVICES_MONITORING_STATUS_CLEAR"
}
export const GET_DEVICES_DASHBOARD_DATA = {
    INIT:    'GET_DEVICES_DASHBOARD_DATA_INIT',
    SUCCESS: 'GET_DEVICES_DASHBOARD_DATA_SUCCESS',
    ERROR:   'GET_DEVICES_DASHBOARD_DATA_ERROR',
    CLEAR:   'GET_DEVICES_DASHBOARD_DATA_CLEAR'
};